export default [
  "!Busi/Base/~query/order/GET_CORE_ORDER.PRODUCT_LIST",
  "!Partner/JY/~java/JY_AllCompare.compare", //活体认证对比
  "!Busi/WoegoOpenAccount/~java/WoegoOpenAccount.openAccount",//开户
  "!Busi/Base/~query/order/GET_CORE_ORDER.PRODUCT_LIST",//订单产品信息



  '!Busi/TYXBOpenAccount/~java/TYXBOpenAccount.createOrder',//天翼小白创建订单
    "!Partner/JY/~java/JY_FaceCompare.compareImage",//云从活体对比
]